var exports = {
  "wrap": "x234b8571--6e65b0--wrap",
  "tabs": "x234b8571--6e65b0--tabs",
};

module.exports = exports;
